<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<template>
  <div>
    <h2>Otras representaciones de la Virgen de Guadalupe</h2>
    <img @click="imageClicked(0)" src="galerias/guadalupe/g6_2/G6_2_A.jpg" class="mainphoto"/>
    <p class="photo-description">Virgen de Guadalupe. Escultura tallada en marfil. Anónimo. Siglo XVIII. Col. Antigüedades Rodrigo Rivero Lake</p>
  </div>
</template>

<script>
export default {
  name: "Sala2m5s2",
  data() {
    return {};
  },
  methods: {
    imageClicked(idx) {
      this.$emit("onImageClicked", idx);
    }
  },
  components: {},
  props: {},
  mounted() {},
};
</script>
